import { MosaicConfigNamed } from '@models/mosaicConfig/MosaicConfigNamed'
import { request } from '../request'
import { AxiosResponse } from 'axios'
import { MosaicsConfigResponseDTO } from '@models/api/mosaicConfig/MosaicsConfigResponseDTO'
import { MosaicConfigIdentifiedDTO } from '@models/api/mosaicConfig/MosaicConfigIdentifiedDTOAPI'

const BASE_URL = 'mosaicConfiguration'

type MosaicPostResponse = {
  ID_MOSAIC: number
}

export const mosaicConfiguration = {
  postForUser: async function (
    mosaicConfig: MosaicConfigNamed
  ): Promise<AxiosResponse<MosaicPostResponse>> {
    return request.post(`${BASE_URL}/user`, {
      config: JSON.stringify(mosaicConfig)
    })
  },
  postForOrganization: async function (
    mosaicConfig: MosaicConfigNamed
  ): Promise<AxiosResponse<MosaicPostResponse>> {
    return request.post(`${BASE_URL}/organization`, {
      config: JSON.stringify(mosaicConfig)
    })
  },
  get: async function (): Promise<AxiosResponse<MosaicsConfigResponseDTO>> {
    return request.get(`${BASE_URL}`)
  },
  delete: async function (
    id: MosaicConfigIdentifiedDTO['ID_MOSAIC']
  ): Promise<AxiosResponse<void>> {
    return request.delete(`${BASE_URL}`, {
      params: { id }
    })
  }
}
